module.exports = __webpack_public_path__ + "img/hm_block01_tc.e2a1da07.jpg";